import { useCallback, useImperativeHandle, useLayoutEffect, useRef, type ForwardedRef } from 'react';
import { px } from '@/lib/utils';

export const useTextareaAutoResize = (
  forwardedRef: ForwardedRef<HTMLTextAreaElement>,
  value: string,
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void,
  maxHeight: number,
) => {
  const internalRef = useRef<HTMLTextAreaElement>(null);
  useImperativeHandle(forwardedRef, () => internalRef.current!);

  useLayoutEffect(() => {
    if (!value && internalRef.current) {
      internalRef.current.style.height = 'auto';
    }
  }, [value]);

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      onChange(e);
      const el = e.target;
      el.style.height = 'auto';
      el.style.height = px(Math.min(el.scrollHeight, maxHeight));
    },
    [onChange, maxHeight],
  );

  return { ref: internalRef, handleChange };
};
